import { useQuery } from "@tanstack/react-query";
import { getDuvidasFrequentes } from "../../../api";

const useGetDuvidasFrequentes = () => {
    const { data, isLoading, isError, error } = useQuery({
        queryKey: ['get_duvidas_frequentes'], // isso aqui serve parar criar um apelido em cache, 
        enabled: true, // só vai chamar a request quando esse valor tiver como true. pode ser usado quando quer disparar uma chamada após uma flag ser ativa por exemplo
        queryFn: () => getDuvidasFrequentes(), // aqui sera aonde vc passa a funcao que chamada a request de API
        /*staleTime: 60000,*/ // Criar um cache na request em milisegundos. Isso e bom para evitar requisitar a api diversas vezes para o backend.,
        refetchOnWindowFocus: false // isso aqui serve para quando o usuario voltar para a aba, ele não chamar a request novamente
    });

    return {
        data, // esse data retornado do hook e o valor retornado de fato da api,
        isLoading, // esse isLoading indica quando voce esta tentando buscar os dados do endpoint. Isso [e] bom para quando vc quer mostrar um icone de loading enquanto carrega,
        isError, // isso retorna caso deu erro ou nao na sua requisicao
        error, // aqui retorna um objeto com erro detalhado
    }

    // react query possui muito mais opcoes. Basta configurar conforme a necessidade. Veja na doc: https://tanstack.com/query/latest/docs/framework/react/quick-start
};

export default useGetDuvidasFrequentes